const NEW_SUBSCRIBER_TILE_SLUG = "new-subscriber";

export function shouldHideNewSubscriberListOptIn(tileSlug: string): boolean {
  return tileSlug === NEW_SUBSCRIBER_TILE_SLUG;
}
